import { render, staticRenderFns } from "./b-popup-customer.vue?vue&type=template&id=afa03024&scoped=true"
import script from "./b-popup-customer.vue?vue&type=script&lang=js"
export * from "./b-popup-customer.vue?vue&type=script&lang=js"
import style0 from "./b-popup-customer.vue?vue&type=style&index=0&id=afa03024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa03024",
  null
  
)

export default component.exports